<template>
  <v-app id="terms-of-service-app">
    <Modal class="termsOfServiceModal">
      <div slot="header">
      </div>
      <div slot="body">
        <section v-if="!managing" class="defaultBody">
          <h4>Acknowlege Terms (required to use the service)</h4>
          <p class="documents">By continuing, you aknowledge that you have read and understand HP's 
            <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
            <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
            and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
          </p>
          <h4>Optional Privacy Consents</h4>
          <p v-if="!brandingService.isGov() && userObject && userObject.isUserAdmin()" class="documents">Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements.</p>
          <p class="documents">I consent to recieve communications from HP, which I understand I may opt out of at any time.</p>
          <button class="consentButton btn btn-primary" @click="consent">Accept All</button>
          <button class="consentButton btn btn-default" @click="manage">Manage Options</button>
          <p class="consentFooter">Accept All applies only to Optional Privacy Consents</p>
        </section>
        <section v-if="managing" class="manageBody">
          <div class="termsOutline">
            <div class="left">
              <h4>Acknowlege Terms (required to use the service)</h4>
              <p class="documents">
                By continuing, you aknowledge that you have read and understand HP's 
                <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
                <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
                and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
              </p>
            </div>
            <div class="right">
              <label align="left" class="legend-title legend-switch action-switch">
                <input id="enabled" type="checkbox" checked v-model="termsAccepted">
                <span class="legend-slider"></span>
              </label>
            </div>
          </div>
          <h4>Optional Privacy Consents</h4>
          <v-checkbox
              v-if="!brandingService.isGov() && userObject && userObject.isUserAdmin()"
              v-model="orgDataConsent"
              class="communications"
              label="Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements."
              hide-details
          ></v-checkbox>
          <v-checkbox
              v-model="userCommunicationConsent"
              class="communications"
              label="I consent to recieve communications from HP, which I understand I may opt out of at any time."
              hide-details
          ></v-checkbox>
          <button class="consentButton btn btn-primary" :disabled="!termsAccepted" @click="consent">Save</button>
          <button class="consentButton btn btn-default" @click="manage">Cancel</button>
        </section>
      </div>
      <div slot="footer"></div>
    </Modal>
  </v-app>
</template>

<script>
  import BrandingService from '../../services/branding.service';
  import DataProvider from  '../../app/data-framework/data-provider';
  import LoginService from '../../services/login.service';
  import WebResourceSecure from '../../modules/assurance/services/web-resource-secure.service';
  import Modal from '../../vueComponents/modal/src/modal.vue';

  export default {
    name: 'TermsOfService',
    data: () => {
      const dataProvider = DataProvider.getInstance();
      return {
        brandingService: BrandingService,
        dataProvider,
        managing: false,
        orgDataConsent: false,
        termsAccepted: false,
        userCommunicationConsent: false,
        userObject: LoginService.userObject,
      };
    },
    props: {
      route: {
        type: Object,
        default: () => {}
      },

    },
    components: {
      Modal,
    },
    methods: {
      consent: function() {
        let self = this;
        const optIn = self.userCommunicationConsent;
        const dataOptIn = self.orgDataConsent;
        self.dataProvider.fetchAssuranceDashboardServiceBaseURL().then(function (serviceUrl) {
          WebResourceSecure.getJSON(serviceUrl + '/userInfo/consent',
              {
                "optIn": optIn,
                "dataOptIn": dataOptIn,
              },
              'POST'
          ).then((appsUserInfo)  => {
            if (appsUserInfo && appsUserInfo.consentJson) {
              LoginService.userObject.consentJson = JSON.parse(appsUserInfo.consentJson)
              window.location.hash = "#" + self.route.prevURL || self.dataProvider.getDefaultLocation();
            }
          });
        });
      },
      manage: function() {
        this.managing = !this.managing;
      }
    }
  }
</script>

<style lang="scss">
  #terms-of-service-app {
    .modal-container {
      width: 576px;
      padding: 50px;
      border-radius: var(--border-radius);

      .modal-body {
        padding: 0;
      }

      .termsOutline {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        border: 1px solid var(--stroke-decorative-default);
        padding: 15px;
        border-radius: var(--border-radius);

        .left {
        }
        .right {
        }
      } 
      .documents {
        font-size: 18px;
        line-height: 27px;
        letter-spacing: unset;
        margin-bottom: 30px;
      }

      .communications {
        margin: 0;
        .v-label {
          font-size: 18px;
          font-weight: 400;
          color: var(--text-color);
          line-height: 27px;
          letter-spacing: unset;
        }
        .v-input--selection-controls__input .v-icon {
          color: var(--text-color);
        }
        .v-input__slot {
            align-items: flex-start;
        }

        .v-input--selection-controls__input {
            margin-top: 2px;
        }
      }

      .consentButton {
        margin-top: 75px;
        margin-right: 15px;
        letter-spacing: unset;
        border-radius: var(--border-radius);
      }
      .consentFooter {
        margin-top: 20px;
        font-size: 12px;
        color: var(--foreground-medium)
      }
    }
    .modal-header, .modal-footer {
      display: none;
    }
  }
</style>
